import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '../store'

export default () => {
  const { messengerFrame } = useSelector((state: AppState) => state.application)

  useEffect(() => {
    messengerFrame?.contentWindow?.scrollTo(0, 0)
  }, [])

  return null
}